<template>
  <font-awesome-icon
    icon="map"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faMap } from '@fortawesome/free-solid-svg-icons'

library.add(faMap)

export default {
  name: 'CoozzyMapIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
